// TanStack Query hooks for the Skill Registry list/detail endpoints — same
// shape as entities/agent/model/useAgentToolsQuery.ts.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { getSkill, listSkills } from '@/services/skills';
import type { Skill, SkillDetail } from './types';
import { skillKeys } from './queryKeys';

export function useSkillsQuery(): UseQueryResult<Skill[]> {
  return useQuery<Skill[]>({
    queryKey: skillKeys.list(),
    queryFn: () => listSkills(),
  });
}

export function useSkillQuery(skillId: string | null): UseQueryResult<SkillDetail> {
  return useQuery<SkillDetail>({
    queryKey: skillKeys.detail(skillId ?? ''),
    queryFn: () => getSkill(skillId as string),
    enabled: (skillId ?? '').length > 0,
  });
}
